globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.FormMediaFolder = (function(superClass) {

  utils.extend(FormMediaFolder, superClass);

  FormMediaFolder.ajaxResourcePath = "/configuration/mediatheque/dossiers";

  function FormMediaFolder() {
    return FormMediaFolder.__super__.constructor.apply(this, arguments);
  }

  $.extend(FormMediaFolder.prototype, {
    init: function() {
      var modal = this;

      modal._initEvents();

      return FormMediaFolder.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data){
      var modal = this;

      if(modal.getLevel() > 1) {
        return FormMediaFolder.__super__.callbackSuccess.apply(this, arguments);
      } else {
        if(data.data && data.data.redirect_url) {
          window.location = data.data.redirect_url;
        } else {
          location.reload();
        }
      }
    },
    updateView: function(data) {
      var $subModal = $('.modal.associate-media-images-folder');
      if($subModal.length && data.response) {
        $subModal.find('select').append(new Option(data.data.public_title, data.data.id, true, true)).trigger('change');
      }
    },
    _initEvents: function(){
      var modal = this;

      modal.$html.on('keyup', 'input#accounts_media_images_folder_public_title', function(){
        if($(this).val() != "") {
          modal.$html.find('button.submit').prop('disabled', false);
        } else {
          modal.$html.find('button.submit').prop('disabled', true);
        }
      });
    }
  });

  return FormMediaFolder;

})(appCustomerSpace.Modal);
